import React from "react";

import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemAvatar,
  Avatar,
  ListItemText,
  Divider
} from "@material-ui/core";

import HomeIcon from "@material-ui/icons/Home";
import ParkingIcon from "@material-ui/icons/LocalParking";
import StoreIcon from "@material-ui/icons/Store";
import LocationCityIcon from "@material-ui/icons/LocationCity";
import HotelIcon from "@material-ui/icons/Hotel";
import SchoolIcon from "@material-ui/icons/School";
import ActivityIcon from "@material-ui/icons/LocalActivity";
import PlaceIcon from "@material-ui/icons/Place";
import LaunchIcon from "@material-ui/icons/Launch";
import DirectionsBikeIcon from "@material-ui/icons/DirectionsBike";

import StatusChip from "./StatusChip";

const icons = {
  Dwellings: HomeIcon,
  "Floors above ground": LocationCityIcon,
  "Car parks": ParkingIcon,
  "Retail (sq.m)": StoreIcon,
  "Recreation (sq.m)": ActivityIcon,
  "Office (sq.m)": LocationCityIcon,
  "Hotel rooms": HotelIcon,
  "Education (sq.m)": SchoolIcon,
  "Student Accommodation": HotelIcon,
  "Serviced apartments": HotelIcon,
  "Bike Spaces": DirectionsBikeIcon,
  default: PlaceIcon
};

export default React.memo(
  function Development(props) {
    const {
      address,
      status,
      space_use,
      permit_id,
      more_details
    } = props.development;

    const properties = JSON.parse(space_use).filter(p => p.label !== "");

    const url = new URL(more_details);

    return (
      <Box key={permit_id} pt={{ md: 1 }}>
        <Box pl={{ xs: 0, md: 2 }} pr={{ xs: 0, md: 2 }} pt={{ md: 1 }}>
          <Box
            fontFamily="Gotham, 'Proxima Nova', 'Avenir Next', Helvetica, Arial"
            fontSize={30}
            lineHeight={1.4}
            color="grey800"
            mb={2}
          >
            {address}
          </Box>
          <StatusChip status={status} />
        </Box>
        <List>
          {properties.map((p, i) => {
            const Icon = icons[p.label] ? icons[p.label] : icons["default"];

            return (
              <ListItem key={i}>
                <ListItemAvatar>
                  <Avatar>
                    <Icon />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary={p.label} secondary={p.value} />
              </ListItem>
            );
          })}
          <Divider light />
          <ListItem button component="a" target="_blank" href={more_details}>
            <ListItemText primary="More information" secondary={url.host} />
            <ListItemIcon>
              <LaunchIcon />
            </ListItemIcon>
          </ListItem>
        </List>
      </Box>
    );
    /**
     * memo areEqual function that checks the developments data being passed down
     * are the same. This prevents unnecessary re-rendering.
     */
  },
  ({ development: prev }, { development: next }) =>
    JSON.stringify(prev) === JSON.stringify(next)
);
